<template>
  <div class="mission-start-form-fields">
    <v-text-field dense v-model="form.name" label="Description" />
    <v-text-field dense v-model="form.thirdPartyCode" :label="getTerminology('missions.third_party_code') || 'Reference'" />
    <colleague-select :value.sync="form.inspectedBy" :label="getTerminology('missions.inspected_by') || 'Inspected By'" />
    <mission-custom-fields :mission="mission" :value.sync="form.data" :required="!!mission" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ColleagueSelect from "@/components/Colleague/ColleagueSelect";
import MissionCustomFields from "@/components/Mission/MissionCustomFields";

export default {
  props: {
    mission: {
      type: Object,
    },
  },
  components: {
    ColleagueSelect,
    MissionCustomFields,
  },
  data: () => ({
    form: {
      name: "Asset Maintenance",
      thirdPartyCode: "",
      inspectedBy: "",
      data: {},
    },
  }),
  computed: {
    ...mapGetters("config", ["getTerminology"]),
  },
  created() {
    this.setForm();
  },
  watch: {
    mission() {
      this.setForm();
    },
    form: {
      handler(value) {
        this.$emit("update:form", value);
      },
      deep: true,
    },
  },
  methods: {
    setForm() {
      if (this.mission) {
        this.form.name = this.mission.name || "";
        this.form.thirdPartyCode = this.mission.thirdPartyCode || "";
        this.form.inspectedBy = this.mission.inspectedBy || "";
        this.form.data = this.mission.data || {};
      }
    },
  },
};
</script>
